export default __webpack_public_path__ + "static/media/apilador.dd86f9fc.png";